import React from 'react';
import { cn } from '@/lib/utils';
import { ProductStatus } from '@/types';
import { useModalAction } from '@/components/modal-views/context';
import routes from '@/config/routes';
import Image from '@/components/ui/image';
import FavoriteButton from '@/components/favorite/favorite-button';
import FollowButton from '@/components/follow/follow-button';
import AnchorLink from '@/components/ui/links/anchor-link';
import { logoPlaceholder } from '@/utils/placeholders';
import Avatar from 'react-avatar';

interface GenerateHeaderProps {
  name: string;
  productStatus: ProductStatus;
  product: any;
}

export const GenerateHeader: React.FC<GenerateHeaderProps> = ({
  name,
  productStatus,
  product,
}) => {
  const { openModal } = useModalAction();

  return (
    <div className="mb-8">
      {/* Main header content */}
      <div className="flex flex-col space-y-4">
        {/* Title row */}
        <div className="flex flex-wrap items-center gap-2 sm:gap-3">
          <h1 className="text-xl font-bold sm:text-2xl">
            {name.length > 18 ? name.substring(0, 18) + '...' : name}
          </h1>
          <span
            className={cn(
              'rounded-full px-2 py-1 text-xs text-white',
              productStatus === ProductStatus.Publish
                ? 'bg-brand'
                : productStatus === ProductStatus.UnderReview
                ? 'bg-blue-400'
                : 'bg-yellow-500'
            )}
          >
            {productStatus === ProductStatus.Publish
              ? 'Public'
              : productStatus === ProductStatus.UnderReview
              ? 'Under Review'
              : productStatus === ProductStatus.UnPublish
              ? 'Unpublished'
              : 'Private'}
          </span>
          <FavoriteButton size="xs" productId={product.id} />
        </div>

        {/* Author and model row */}
        <div className="flex flex-col border-b border-gray-100 pb-4 dark:border-gray-800 sm:flex-row sm:items-center sm:justify-between">
          <div className="mb-3 flex items-center gap-3 sm:mb-0">
            <div className="flex items-center">
              <span className="mr-3 text-sm text-gray-500">by</span>
              <div className="relative h-8 w-8">
                {!product.shop.logo?.thumbnail ? (
                  <Avatar
                    size="32"
                    round={true}
                    name={product.shop.name}
                    textSizeRatio={2}
                  />
                ) : (
                  <Image
                    alt={product.shop.name}
                    src={logoPlaceholder}
                    className="rounded-full"
                    width={32}
                    height={32}
                  />
                )}
              </div>
              <div className="ml-2">
                <AnchorLink
                  href={routes.shopUrl(product.shop?.slug)}
                  className="text-sm font-medium hover:text-brand"
                >
                  {product.shop.name}
                </AnchorLink>
              </div>
              <div className="ml-2 flex items-center gap-2">
            <FollowButton
              size='xs'
              shop_id={product.shop.id}
            />
          </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};
